// extracted by mini-css-extract-plugin
module.exports = {"container":"EnterTwoFactorCode-module__container___SYwRf","verificationCard":"EnterTwoFactorCode-module__verificationCard___totVK"};